import { trackKnownAnalyticsEvent } from "../analyticsClient";

export type ComicFavoriteEventInput = {
  comicId: number;
  source: string;
  impressionId?: string;
};

export type ComicUnfavoriteEventInput = {
  comicId: number;
  source: string;
};

export type ComicSubscriptionEventInput = {
  comicId: number;
  source: string;
  impressionId?: string;
};

export type ArtistEngagementEventInput = {
  artistId: number;
  source: string;
  impressionId?: string;
};

export type ReleaseReactionEventInput = {
  releaseId: number;
  comicId: number;
  reactionType: string;
  source: string;
};

export type OfflineReleaseDownloadEventInput = {
  releaseId: number;
  comicId: number;
  totalPages: number;
  source: string;
};

export function trackComicFavorite(params: ComicFavoriteEventInput): void {
  trackKnownAnalyticsEvent("comic_favorite", {
    comicId: params.comicId,
    source: params.source,
    impressionId: params.impressionId,
  });
}

export function trackComicUnfavorite(params: ComicUnfavoriteEventInput): void {
  trackKnownAnalyticsEvent("comic_unfavorite", {
    comicId: params.comicId,
    source: params.source,
  });
}

export function trackComicSubscribe(params: ComicSubscriptionEventInput): void {
  trackKnownAnalyticsEvent("comic_subscribe", {
    comicId: params.comicId,
    source: params.source,
    impressionId: params.impressionId,
  });
}

export function trackComicUnsubscribe(
  params: ComicSubscriptionEventInput,
): void {
  trackKnownAnalyticsEvent("comic_unsubscribe", {
    comicId: params.comicId,
    source: params.source,
    impressionId: params.impressionId,
  });
}

export function trackArtistFollow(params: ArtistEngagementEventInput): void {
  trackKnownAnalyticsEvent("artist_follow", {
    artistId: params.artistId,
    source: params.source,
    impressionId: params.impressionId,
  });
}

export function trackArtistUnfollow(params: ArtistEngagementEventInput): void {
  trackKnownAnalyticsEvent("artist_unfollow", {
    artistId: params.artistId,
    source: params.source,
    impressionId: params.impressionId,
  });
}

export function trackReleaseReaction(
  params: ReleaseReactionEventInput,
): void {
  trackKnownAnalyticsEvent("release_reaction", {
    releaseId: params.releaseId,
    comicId: params.comicId,
    reactionType: params.reactionType,
    source: params.source,
  });
}

export function trackOfflineReleaseDownload(
  params: OfflineReleaseDownloadEventInput,
): void {
  trackKnownAnalyticsEvent("offline_release_download", {
    releaseId: params.releaseId,
    comicId: params.comicId,
    totalPages: params.totalPages,
    source: params.source,
  });
}
